import { render, staticRenderFns } from "./HruTable.vue?vue&type=template&id=270e59ba&"
import script from "./HruTable.vue?vue&type=script&lang=js&"
export * from "./HruTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports